import { Modal } from "antd";
import { ShowToast, Severty } from "../helper/toast";
import useRequest from "../hooks/useRequest";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const ConfirmationBox = () => {

  const { request } = useRequest();

  const showConfirm = ({ record, path, onLoading, onSuccess, type, title, content, method, data, icon, okText, cancelText, okButtonProps }) => {
    setTimeout(() => {
      Modal.confirm({
        title: title || 'Are you sure?',
        content: content || 'Do you want to proceed with this action?',
        icon: icon || <ExclamationCircleOutlined />,
        okText: okText || 'Confirm',
        cancelText: cancelText || 'Cancel',
        centered: true,
        width: 450,
        maskClosable: false,
        okButtonProps: okButtonProps || {},
        onOk: () => {
          return statusChange(record, path, onLoading, onSuccess, type, method, data);
        }
      });
    }, 10);
  };

  const statusChange = async (record, path, onLoading, onSuccess, type, method = 'GET', data = null) => {
    if (onLoading) onLoading(true);

    let url = '';

    if (type !== null && type !== undefined) {
      url = path + "/" + type + "/" + (record || '')
    } else {
      url = path + (record ? "/" + record : '')
    }

    try {
      await request({
        url: url,
        method: method,
        data: data,
        onSuccess: (response) => {
          onSuccess();
        },
        onError: (error) => {
          ShowToast(error?.response?.data?.message || "Something went wrong", Severty.ERROR)
        }
      });
    } finally {
      if (onLoading) onLoading(false);
    }
  };

  return { showConfirm }

};

export default ConfirmationBox;
